__turbopack_context__.v({
  "link": "shareLinks-module-scss-module__XCyFDa__link",
  "menu": "shareLinks-module-scss-module__XCyFDa__menu",
  "menuDisabled": "shareLinks-module-scss-module__XCyFDa__menuDisabled",
  "menuOpen": "shareLinks-module-scss-module__XCyFDa__menuOpen",
  "menuOpenOne": "shareLinks-module-scss-module__XCyFDa__menuOpenOne",
  "platformButton": "shareLinks-module-scss-module__XCyFDa__platformButton",
  "platformIcon": "shareLinks-module-scss-module__XCyFDa__platformIcon",
  "platforms": "shareLinks-module-scss-module__XCyFDa__platforms",
  "platformsClosed": "shareLinks-module-scss-module__XCyFDa__platformsClosed",
  "root": "shareLinks-module-scss-module__XCyFDa__root",
  "shareIcon": "shareLinks-module-scss-module__XCyFDa__shareIcon",
});
